import Vue from 'vue'
import I18n from 'vue-i18n'

Vue.use(I18n)

export default new I18n({
  locale: 'fr',

  messages: {
    fr: require('../locales/fr.json')
  }
})



// WEBPACK FOOTER //
// ./src/config/locale.js